module.exports = __webpack_public_path__ + "img/google-pay.4e4974cf.svg";